<img
  class="avatar"
  width="{{ width }}"
  height="{{ height }}"
  src="./assets/imgs/{{ name }}.jpg"
  alt="avatar {{ name }}"
/>
